/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type ListEvaluationRunResultsPathParams = NonNullable<
  operations['listEvaluationRunResults']['parameters']['path']
>;

export type ListEvaluationRunResultsQueryParams = NonNullable<
  operations['listEvaluationRunResults']['parameters']['query']
>;

export interface Input extends ListEvaluationRunResultsPathParams {
  apiVersion?: string;
  query?: ListEvaluationRunResultsQueryParams;
}

export async function listEvaluationRunResults(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/internal/projects/{projKey}/evaluations/{evaluationId}/runs/{runId}/rows', {
    params: { path, query },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
